<template>
<div class="top-menu">
  <div class="width-container">
    <router-link to='/'><img class="logo" src="../assets/logo_rojeca.svg"/></router-link>
    <i class="fa medium menu-toggle" :class="{'times': menuToggled, 'hamburger': !menuToggled}" @click="menuToggle"/>
    <ul class="menu-items" :class="{'s-active': menuToggled}">
      <li v-for="(item, i) in menuItems" :key="i">
          <router-link :to="item.url">{{ item.name }}</router-link>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
export default {
  name: 'TopMenu',
  props: {
    menuItems: Array,
  },
  data() {
    return {
      menuToggled: 0,
    }
  },
  methods: {
    menuToggle() {
      if (this.menuToggled === 1) {
        this.menuToggled = 0;
      } else {
        this.menuToggled = 1;
      }
    }
  }
}
</script>

<style scoped>
  .top-menu {
    display: flex;
    justify-content: center;
    height: var(--menu-height);
    align-items: center;
  }

  .top-menu .width-container {
    display: flex;
    width: 840px;
  }

  .menu-items {
    display: flex;
    list-style: none;
    justify-content: flex-end;
    align-items: center;
    flex-basis: 100%;
  }

  .menu-items a {
    color: var(--foreground-color);
    text-decoration: none;
    text-transform: capitalize;
    padding-bottom: 3px;
  }

  .menu-items a:hover {
    border-bottom: 3px solid var(--secondary-color-fade);
  }

  .menu-items li {
    margin-right: var(--item-margin);
  }

  .menu-items a.router-link-exact-active {
    border-bottom: 3px solid var(--secondary-color);
  }

  .top-menu .logo {
    height: 64px;
    object-fit: contain;
  }

  .menu-toggle {
    display: none;
    cursor: pointer;
  }
  
  @media only screen and (max-width: 600px) {
    .menu-toggle {
      display: flex;
    }

    .top-menu {
      height: 100px;
    }

    .top-menu .width-container {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 0px calc(var(--mobile-padding) / 2);
    }

    .top-menu .logo {
      height: 40px;
    }

    .top-menu .menu-items {
      right: 0;
      top: 100px;
      position: absolute;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 999;
      background: white;
      padding: 10px 20px;
      margin: 0px;
      box-shadow: 0px 0px 20px #0004;
    }


    .top-menu .menu-items li {
      margin: 0px;
      padding: 10px;
    }

    .menu-items {
      display: none;
    }

    .menu-items.s-active {
      display: flex;
    }

  }

</style>


// WEBPACK FOOTER //
// src/components/top-menu.vue